// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4b-0";
export var eligibilityCardNotEligible = "_4b-1";